
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Phone } from "lucide-react";

interface EmergencyInfoProps {
  standalone?: boolean;
  redText?: boolean;
}

export const EmergencyInfo: React.FC<EmergencyInfoProps> = ({ standalone = false, redText = false }) => {
  const content = (
    <ul className={`space-y-2 ${redText ? 'text-red-600' : 'text-tribal-neutral'} list-disc pl-5`}>
      <li>Cell coverage available. Dialing 911 may connect you to Elko County Dispatch.</li>
      <li>Clearly inform dispatch of your location.</li>
      <li>Local emergency services: (775) 757-3624 (Owyhee Police Department)</li>
    </ul>
  );
  
  if (standalone) {
    return (
      <div className="flex items-start">
        <Phone className={`h-5 w-5 ${redText ? 'text-red-600' : 'text-red-500'} mr-3 mt-1 flex-shrink-0`} />
        <div>
          <h3 className={`text-lg font-medium ${redText ? 'text-red-600' : 'text-tribal-secondary'} mb-2`}>Emergency Information</h3>
          {content}
        </div>
      </div>
    );
  }
  
  return (
    <RegulationItem 
      value="emergency-info" 
      icon={Phone} 
      iconColor="text-red-500" 
      title="Emergency Information"
    >
      {content}
    </RegulationItem>
  );
};
